import React from "react";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { checkIsStringEmpty } from "features/Common/modules/DataTypes/Strings.utils";

export const OfferingNameChips = ({
  listingNames,
}: {
  listingNames: string[];
}) => {
  if (checkIsArrayEmpty(listingNames)) return <>-</>;

  return (
    <div className="tw-flex tw-flex-wrap tw-gap-2 tw-py-[10px]">
      {listingNames.map((listingName) => {
        if (checkIsStringEmpty(listingName)) return "N/A";
        return (
          <div
            key={listingName}
            className="tw-border-solid tw-border-[1px] tw-border-[#493ab1] tw-bg-[#eeecf9] tw-text-[#493ab1] tw-text-sm tw-font-normal tw-leading-[22px] tw-rounded tw-px-2 tw-w-fit"
          >
            {listingName}
          </div>
        );
      })}
    </div>
  );
};
